import { render, staticRenderFns } from "./registration-steps.vue?vue&type=template&id=1b07685f"
import script from "./registration-steps.vue?vue&type=script&lang=js"
export * from "./registration-steps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports